import React, { useState } from "react";
import { observer } from "mobx-react";
import { ListBox } from "primereact/listbox";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { ProgressBar } from "primereact/progressbar";
import { Button } from "primereact/button";
import { FormControlProps } from "../../components/validation/FormControlled";
import { screenSize, useMediaQuery } from "../../hooks/responsiveLayout";
import { classNames } from "primereact";
import { ContactGroup } from "../../api/firebase/types/contact.types";
import ContactGroupStore from "../../store/ContactGroupStore";
import AddContactGroupModal from "./AddContactGroupModal";

export type ContactGroupListCardProps = {
  contactGroups: ContactGroup[];
  className?: string;
  useFormMethods: FormControlProps;
};

const ContactGroupListCard: React.FC<ContactGroupListCardProps> = ({
  contactGroups,
  className,
  useFormMethods,
}) => {
  const [isAddDialogVisible, setIsAddDialogVisible] = useState(false);
  const [showLoader, setShowLoader] = useState<boolean>(false);

  const [width] = useMediaQuery();

  const addContactGroupButton = (
    <Button
      key="add-button"
      icon="pi pi-plus"
      className="p-button-text"
      style={{ height: 40 }}
      label="Neue Kontaktgruppe"
      onClick={() => setIsAddDialogVisible(true)}
    />
  );

  const handleContactGroupChange = (contactGroupId: string) => {
    useFormMethods.reset();
    ContactGroupStore.setCurrentContactGroup(contactGroupId);
  };

  return (
    <Card
      className={classNames("devicelist p-col", {
        "p-mr-2": width >= screenSize.tablet,
      })}
    >
      {showLoader && <ProgressBar mode="indeterminate" />}
      <Toolbar
        left={() => <h2>Kontaktgruppen</h2>}
        right={() => addContactGroupButton}
      />
      <p className="p-mt-0">
        <i>
          Erstellen Sie hier Kontaktgruppen, welche den jeweiligen Szenarien
          zugewiesen werden können. Alle Mitglieder einer Kontaktgruppe werden
          bei Auslösung des Szenarios auf die beim Kontakt angegebene Weise
          benachrichtigt.
        </i>
      </p>
      {contactGroups.length > 0 ? (
        <ListBox
          className={className}
          value={ContactGroupStore.currentContactGroupId}
          options={contactGroups}
          optionValue="id"
          optionLabel="label"
          onChange={(e) => handleContactGroupChange(e.value)}
        />
      ) : (
        <p>
          <i>Keine Kontaktgruppen vorhanden</i>
        </p>
      )}
      <AddContactGroupModal
        isVisible={isAddDialogVisible}
        closeModal={() => setIsAddDialogVisible(false)}
        showLoader={setShowLoader}
      />
    </Card>
  );
};

export default observer(ContactGroupListCard);
